import axios from "axios";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { HttpJsonHeader } from "../../../features/Environments";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";
import {
  CreateTooltip,
  FormAuto,
  FormAutoB,
  getRandomBase64Text,
} from "../../../core/Helper";
import QrCodeGenerator from "../../../components/QrCodeGenerator";
import { Button } from "react-bootstrap";
import { FaICursor, FaLine, FaPray } from "react-icons/fa";
import { AiFillSave } from "react-icons/ai";
import { BsPerson } from "react-icons/bs";
import { encode } from "js-base64";
import { BiKey } from "react-icons/bi";
import { GiConfirmed } from "react-icons/gi";
import ConfirmDialogB from "../../components/ConfirmDialogB";
import { FiAlertCircle } from "react-icons/fi";
import styled from "styled-components";

export default function UserProfile(props) {
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.user.detail);
  const [data, setData] = useState();
  const [component, setComponent] = useState();
  const [qrShow, setQrShow] = useState({ show: false, action: () => {} });

  const [oldPws, setOldPws] = useState("");
  const [newPws, setNewPws] = useState("");
  const [conPws, setConfPws] = useState("");

  const [prefix, setPrefix] = useState(1);
  const [gender, setGender] = useState(1);

  const [confirmDlg, setConfirmDlg] = useState({
    show: false,
    title: "",
    action: () => {},
  });

  const refForm1 = useRef(null);

  //** Register Line user to server */
  const doRegisterLineUser = (code, callback) => {
    axios
      .post(
        process.env.REACT_APP_API + "api/webhook/1ine-login-authen-callback",
        { staffId: userDetail?.staffid, code: code },
        HttpJsonHeader
      )
      .then((res) => {
        callback(res);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    /** Session Item response to LINE-Login Request by these steps
     * 1. User Register Line Login Chnnel callback
     * 2. Line has callback to provided callback URL.
     * 3. Register Line at server side
     * 4. send back user info to client
     *  Origined from App.js ==> A02_RadRoutes.js => UserProfile.js
     */
    let lineLoginRegister = sessionStorage.getItem(
      "line_login_register_request_state"
    );
    if (lineLoginRegister) {
      let objLine = JSON.parse(lineLoginRegister);
      let lineCode = sessionStorage.getItem("line_login_register_request_code");
      if (objLine?.dataType === "line_login") {
        doRegisterLineUser(lineCode, (res) => {
          sessionStorage.removeItem("line_login_register_request_state");
          sessionStorage.removeItem("line_login_register_request_code");
          dispatch(
            setReminder({
              show: true,
              message: "ลงทะเบียนเสร็จสิ้น",
              type: "success",
            })
          );
          //loadDefaultData();
        });
      }
    }
    //else {
    //*โหลดข้อมูลพนักงาน
    // getData();
    //loadDefaultData();
    //}
    loadDefaultData();

    //**return */
    return () => {
      setComponent(null);
      setData(null);
    };
  }, []);

  const remindsError = (msg) => {
    dispatch(setReminder({ show: true, message: msg, type: "error" }));
  };
  const remindsSuccess = (msg) => {
    dispatch(setReminder({ show: true, message: msg, type: "success" }));
  };

  const updatePassAction = () => {
    if (oldPws === "") {
      remindsError("ระบุรหัสผ่านปัจจุบัน");
      return;
    }
    if (newPws === "" || conPws === "") {
      remindsError("ระบุรหัสผ่านใหม่");
      return;
    }
    if (newPws !== conPws) {
      remindsError("กรุณาตรวจสอบรหัสผ่านใหม่");
      return;
    }

    let value = {
      oldPass: oldPws,
      newPass: newPws,
      confirmNewPass: conPws,
    };

    setConfirmDlg({
      show: true,
      title: "ต้องการเปลี่ยนรหัสผ่าน?",
      action: (result) => {
        if (!result) return;
        axios
          .post(
            process.env.REACT_APP_API + "api/staff/updatePassword",
            { UserInfo: userDetail, data: value },
            HttpJsonHeader
          )
          .then((res) => {
            remindsSuccess(
              "รหัสผ่านเปลี่ยนแล้ว กรุณาทำการ Login ด้วยรหัสผ่านใหม่ของท่าน"
            );
          })
          .catch((err) => {
            remindsError(err?.response?.data?.result);
          });
      },
    });
  };

  //* โหลดข้อมูลส่วนประกอบตัวเลือก
  const loadDefaultData = () => {
    getComponent();
  };

  // useEffect(() => {

  // }, [component]);

  useEffect(() => {
    if (component) {
      getData();
    }
  }, [component]);

  useEffect(() => {
    if (data) {
      setPrefix(data?.PrefixId);
      setGender(data?.GendId);
    }
  }, [data]);

  //** โหลดข้อมูลผู้ใช้ */
  const getData = () => {
    axios
      .post(
        process.env.REACT_APP_API + "api/staff/get-staff-info",
        userDetail,
        HttpJsonHeader
      )
      .then((res) => {
        let result = JSON.parse(res.data);
        setData(result);
      })
      .catch((err) => alert(err));
  };

  //** Get profile components */
  const getComponent = () => {
    axios
      .post(
        process.env.REACT_APP_API + "api/staff/getComponents",
        {},
        HttpJsonHeader
      )
      .then((res) => {
        setComponent(res.data);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  // {
  //   console.log(data);
  // }

  // useEffect(() => {
  //   console.log(data);
  // }, [data]);
  const FieldsA = [
    {
      label: "รหัส/เลข ว.(แพทย์)",
      oName: "StaffCode",
      require: true,
      defaultValue: data?.StaffCode,
      // disabled: true,
      type: "text",
    },

    {
      label: "คำนำหน้า",
      oName: "PrefixId",
      require: false,
      defaultValue: prefix,
      value: prefix,
      setValue: setPrefix,
      type: "select2",
      rows: component?.Prefix,
      // onChange: (e) => {
      //   console.log(console.log(e.target.value));
      // },
    },

    {
      label: "ชื่อ",
      oName: "FirstName",
      require: true,
      defaultValue: data?.FirstName,
      type: "text",
    },

    {
      label: "นามสกุล",
      oName: "LastName",
      require: true,
      defaultValue: data?.LastName,
      type: "text",
    },
    {
      label: "ชื่อเล่น",
      oName: "NickName",
      require: true,
      defaultValue: data?.NickName,
      type: "text",
    },

    {
      label: "เพศ",
      oName: "GendId",
      require: true,
      defaultValue: gender,
      value: gender,
      setValue: setGender,
      type: "select2",
      rows: component?.Gender,
    },

    // {label:"วันเกิด", oName: "oBirthDate", require: true,
    // defaultValue: props.fields==null? Date() : props.fields.ydm_birthdate,
    // type:"date" , handleChange:(date)=>{setStartDate(date)}},

    {
      label: "เบอร์มือถือ",
      oName: "MobileNo",
      require: true,
      defaultValue: data?.MobileNo,
      type: "text",
    },

    {
      label: "Email",
      oName: "Email",
      require: true,
      defaultValue: data?.Email,
      type: "text",
    },

    {
      label: "Line ID",
      oName: "LineId",
      require: true,
      defaultValue: data?.LineId,
      type: "text",
    },
  ];

  const handleQR = () => {
    let kk = getRandomBase64Text();
    setQrShow({
      show: true,
      value: `https://access.line.me/oauth2/v2.1/login?returnUri=%2Foauth2%2Fv2.1%2Fauthorize%2Fconsent%3Fresponse_type%3Dcode%26client_id%3D${lineLoginChanelID}%26scope%3Dprofile%26bot_prompt%3Dagressive%26redirect_uri%3Dhttps%253A%252F%252Font-th.com%26state%3D${
        getRandomBase64Text(10) +
        encode(
          JSON.stringify({ dataType: "line_login", staffId: data?.Staffid })
        )
      }&loginChannelId=${lineLoginChanelID}&loginState=OrFaZKJgVUYFYqCG69Haxn`,
      action: ({ value }) => {
        getData();
        setQrShow({ show: false });
      },
    });
  };

  const handleLineFriend = (value) => {
    setQrShow({
      show: true,
      value: value,
      action: ({ value }) => {
        setQrShow({ show: false, action: () => {} });
      },
    });
  };

  let lineLoginChanelID = process.env.REACT_APP_LINELOGIN_CHANEL_ID;

  // saving data
  const saveData = (evt) => {
    const fData1 = Object.fromEntries(new FormData(refForm1.current));

    let dataToSave = {
      SaveInfo: fData1,
      UserInfo: userDetail,
    };

    console.log(dataToSave);

    /* Send data to Save */
    axios
      .post(
        process.env.REACT_APP_API + "api/staff/profileUpdate",
        dataToSave,
        HttpJsonHeader
      )
      .then((res) => {
        dispatch(
          setReminder({ show: true, message: "บันทึกสมบูรณ์", type: "success" })
        );
        getData();
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  return (
    <div className="profile-main">
      <div style={styles.divStyle1}>
        {data?.LineInfo && data.LineInfo[0]?.PictureUrl ? (
          <div style={styles.divStyle2}>
            <img
              style={{ height: "100px", width: "100px" }}
              src={data.LineInfo[0].PictureUrl}
              alt=""
            />
          </div>
        ) : (
          <BsPerson size={50} style={styles.iconStyle1} />
        )}

        {data?.LineInfo && data.LineInfo[0]?.DisplayName
          ? data?.LineInfo && data.LineInfo[0]?.DisplayName
          : "USER PROFILE"}
      </div>
      <div style={styles.divStyle3}>
        <div style={styles.divStyle4}>
          <FormAuto
            {...{
              formId: "form1",
              items: FieldsA,
              // data: data,
              refTo: refForm1,
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBlock: "10px",
            }}
          >
            <button class="search-btn" onClick={(e) => saveData(e)}>
              <div> บันทึก Profile</div>
            </button>
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <DivPasswordWrapper>
            <div style={{ color: "#4949fc", padding: "8px" }}>
              <BiKey color="#05ec37" size={30} /> เปลี่ยนรหัสผ่านใหม่
            </div>
            <div autoComplete="off">
              <div style={{ color: "#b06107" }}>รหัสผ่านปัจจุบัน</div>
              <input
                className="normal-input-password"
                autoComplete="old-password"
                placeholder="รหัสผ่านปัจจุบัน"
                defaultValue=""
                type="password"
                onChange={(e) => setOldPws(e.target.value)}
              />
              <div style={{ color: "#b06107" }}>รหัสผ่านใหม่:</div>
              <input
                className="normal-input-password"
                type="password"
                autoComplete="new-password"
                placeholder="รหัสผ่านใหม่"
                onChange={(e) => setNewPws(e.target.value)}
                defaultValue=""
              />
              <div style={{ color: "#b06107" }}>ยินยันรหัสผ่านใหม่:</div>
              <input
                className="normal-input-password"
                type="password"
                placeholder="ยืนยันรหัสผ่านใหม่"
                autoComplete="new-password"
                defaultValue=""
                onChange={(e) => setConfPws(e.target.value)}
              />
            </div>
            <div>
              <Button
                className="btnSave"
                onClick={() => {
                  updatePassAction();
                }}
              >
                <GiConfirmed /> เปลี่ยนรหัสผ่าน
              </Button>
            </div>
          </DivPasswordWrapper>

          <DivLineWrapper>
            {CreateTooltip(
              <div style={styles.helpTooltip}>
                <p>1. คลิกปุ่มเพื่อเปิด QR-Code </p>
                <p>2. เปิดแอพพลิเคชั่น LINE บนมือถือหรือสมาร์ทโฟน </p>
                <p>
                  3. ระบบจะทำการ link เข้าหน้าเว็บของ ont-th.com จาก Browser
                  บนมือถือ
                </p>
                <p>
                  4. ทำการเข้าระบบอีกครั้งด้วย Username และ Password บน
                  Browserมือถือ
                </p>
                <p>5. ตรวจสอบ Profile ของท่านอีกครั้ง</p>
              </div>,
              <div>
                <Button
                  variant="success"
                  style={styles.buttonStyle1}
                  onClick={(e) => handleQR()}
                >
                  <FaLine
                    size={50}
                    style={{ fontSize: "35px", marginRight: "3px" }}
                  />
                  <div>ลงทะเบียนรับข้อความ</div>
                  <DivButtonDescription>
                    ยิง QR-Code ลงทะเบียนเพื่อรับข้อความแจ้งเตือน
                  </DivButtonDescription>
                </Button>
              </div>
            )}

            {CreateTooltip(
              <div style={styles.helpTooltip}>
                <p>1. คลิกเพื่อเปิด QR-Code </p>
                <p>2. เปิดแอพพลิเคชั่น LINE บนมือถือหรือสมาร์ทโฟน </p>
                <p>3. ยิง QR เพื่อ Add-Friends </p>
              </div>,
              <div>
                <Button
                  style={styles.buttonStyle1}
                  variant="success"
                  onClick={(e) =>
                    handleLineFriend(`https://line.me/R/ti/p/%40292usxus`)
                  }
                >
                  <FaLine
                    size={50}
                    style={{ fontSize: "35px", marginRight: "3px" }}
                  />
                  <div>เพิ่มเพื่อน</div>
                  <DivButtonDescription>
                    เพิ่ม ONT-TH.COM เป็นเพื่อน
                  </DivButtonDescription>
                </Button>
              </div>
            )}
          </DivLineWrapper>
        </div>
      </div>

      <QrCodeGenerator
        qrOption={[qrShow, setQrShow]}
        // value="https://access.line.me/oauth2/v2.1/login?returnUri=%2Foauth2%2Fv2.1%2Fauthorize%2Fconsent%3Fresponse_type%3Dcode%26client_id%3D2002877915%26scope%3Dprofile%26redirect_uri%3Dhttps%253A%252F%252Font-th.online%26state%3D12345&loginChannelId=2002877915&loginState=OrFaZKJgVUYFYqCG69Haxn"
        // value={`https://access.line.me/oauth2/v2.1/login?returnUri=%2Foauth2%2Fv2.1%2Fauthorize%2Fconsent%3Fresponse_type%3Dcode%26client_id%3D${lineLoginChanelID}%26scope%3Dprofile%26bot_prompt%3Dagressive%26redirect_uri%3Dhttps%253A%252F%252Font-th.com%26state%3D${
        //   getRandomBase64Text(10) +
        //   encode(
        //     JSON.stringify({ dataType: "line_login", staffId: data?.Staffid })
        //   )
        // }&loginChannelId=${lineLoginChanelID}&loginState=OrFaZKJgVUYFYqCG69Haxn`}
      />
      <ConfirmDialogB {...{ winState: [confirmDlg, setConfirmDlg] }} />
    </div>
  );
}

const styles = {
  divStyle1: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px 0 20px 0",
    width: "100%",
  },
  divStyle2: {
    borderRadius: "50px",
    width: "100px",
    height: "100px",
    overflow: "hidden",
    margin: "2px 10px 2px 10px",
  },
  //** กรอบ profile */
  divStyle3: {
    flex: "1",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "start",
    width: "100%",
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  divStyle4: {
    flex: "1",
    flexDirection: "column",
    display: "flex",
    // width: "100%",
    boxShadow: "1px 1px 10px #dbdbdb ",
    padding: "10px",
  },
  divStyle5: {
    flex: "1",
    display: "flex",
    justifyContent: "center",
    marginTop: "10px",
  },
  divStyle6: {
    maxWidth: "250px",
    padding: "2px 2px 2px 2px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    flex: "1",
    margin: "0 12px",
    borderRadius: "5px",
    boxShadow: "1px 1px 10px #dbdbdb ",
  },
  iconStyle1: {
    color: "white",
    borderRadius: "120px",
    backgroundColor: "#18067a",
    padding: "10px",
    marginRight: "5px",
  },
  buttonStyle1: {
    marginBlock: "5px",
    width: "250px",
  },
  helpTooltip: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "start",
    textAlign: "left",
    minWidth: "500px",
    background: "black",
    borderRadius: "10px",
    color: "#ffff44",
    fontSize: "20px",
    lineHeight: "1.2",
    paddingBlock: "15px",
  },
  pLeft: { textAlign: "left" },
};

const DivLineWrapper = styled.div`
  /* border: 1px solid black; */
  display: flex;
  flex-direction: column;
  padding-inline: 20px;
  box-shadow: 1px 1px 10px #dbdbdb;
  border-radius: 5px;
  margin-block-start: 15px;
  margin-left: 15px;
  padding-block: 15px;
  justify-content: center;
  align-items: center;
`;

const DivPasswordWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: 20px;
  box-shadow: 1px 1px 10px #dbdbdb;
  border-radius: 5px;
  margin-left: 15px;
  padding-block: 15px;
`;

const DivButtonDescription = styled.div`
  font-size: 10px;
  color: yellow;
`;
